// ---------------------------------------------
// UNIVERSAL DATA-SWAP SYSTEM FOR HORIZON THEMES
// ---------------------------------------------

function handleVariantSwap(event) {
  const picker = event.currentTarget;

  // 1. Resolve variant ID from DOM (same pattern as BDProductMedia)
  const checked = picker.querySelector("input[data-variant-id]:checked");
  const variantId = checked?.dataset.variantId;

  if (!variantId) {
    console.warn("❌ No variantId resolved — aborting swap");
    return;
  }

  // 2. Find all local swap zones
  const localSwapTargets = document.querySelectorAll("[data-swap]");

  if (!localSwapTargets.length) {
    console.warn("⚠️ No local [data-swap] zones found — nothing to swap");
    return;
  }

  // 3. For each swap zone, fetch its own section and swap
  localSwapTargets.forEach(async (local) => {
    const key = local.dataset.swap;

    // Resolve the correct section for THIS swap zone
    const sectionId = local.closest("[data-section-id]")?.dataset.sectionId;

    if (!sectionId) {
      console.warn(`❌ No section_id found for swap zone "${key}" — skipping`);
      return;
    }

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

    const response = await fetch(url);
    if (!response.ok) {
      console.warn(`❌ Fetch failed for "${key}"`);
      return;
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, "text/html");

    const incoming = doc.querySelector(`[data-swap="${key}"]`);
    if (!incoming) {
      console.warn(
        `❌ No incoming swap target for "${key}" in fetched section`,
      );
      return;
    }

    local.innerHTML = incoming.innerHTML;
  });

  console.log("🔚 SWAP EVENT FINISHED");
}

function attachSwapListeners() {
  const pickers = document.querySelectorAll("variant-picker");

  pickers.forEach((picker) => {
    if (picker._swapListenerAttached) return;
    picker._swapListenerAttached = true;

    picker.addEventListener("variant:update", handleVariantSwap);
  });
}

// Attach on load
attachSwapListeners();

// Reattach after Horizon re-renders sections (if you emit such events)
document.addEventListener("DOMContentLoaded", attachSwapListeners);
document.addEventListener("section:reloaded", attachSwapListeners);
